import React, { Component } from 'react';
import './AirTable.css';
import { Table } from 'antd';
import AirPagination from '../AirPagination';

export default class AirTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: this.props.currentPage || 1
    };
  }

  next = () => {
    const { currentPage } = this.state;
    const { dataSource, pageSize } = this.props;
    const lastPage = Math.ceil(dataSource.length / pageSize);
    if (currentPage < lastPage) {
      this.setState({ currentPage: this.state.currentPage + 1 });
    }
  };

  prev = () => {
    const { currentPage } = this.state;
    if (currentPage > 1) {
      this.setState({ currentPage: this.state.currentPage - 1 });
    }
  };

  render() {
    const { dataSource, pageSize, columns } = this.props;
    const { currentPage } = this.state;
    return (
      <div className={`AirTable ${this.props.className || ''}`}>
        <Table pagination={{ pageSize, current: currentPage, hideOnSinglePage: true }} dataSource={dataSource} columns={columns} />
        <AirPagination pageSize={pageSize} hideOnSinglePage={true} total={dataSource.length} currentPage={currentPage} next={this.next} prev={this.prev} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirTable/AirTable.js